import qs from "qs";

import { ProviderClient } from "./providers";
import { ServiceClient } from "./services";
import { RecommendPackageClient } from "./recommend_packages";
import { CollectionClient } from "./collections";
import { AppointmentClient } from "./appointments";
import { SubscriberClient } from "./subscribers";
import { ReceiptClient } from "./receipts";
import { ServiceCategoryClient } from "./service_categories";
import { CouponClient } from "./coupons";
import { RatingClient } from "./ratings";

export class SubscriptionClient {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/subscriptions`;

    this.coupons = new CouponClient(this.httpClient, this.baseURL);
    this.providers = new ProviderClient(this.httpClient, this.baseURL);
    this.services = new ServiceClient(this.httpClient, this.baseURL);
    this.collections = new CollectionClient(this.httpClient, this.baseURL);
    this.appointments = new AppointmentClient(this.httpClient, this.baseURL);
    this.subscribers = new SubscriberClient(this.httpClient, this.baseURL);
    this.serviceCategories = new ServiceCategoryClient(
      this.httpClient,
      this.baseURL
    );
    this.receipts = new ReceiptClient(this.httpClient, this.baseURL);
    this.recommend_packages = new RecommendPackageClient(
      this.httpClient,
      this.baseURL
    );
    this.ratings = new RatingClient(this.httpClient, baseURL);
  }

  async getReports(params) {
    const queryString = qs.stringify(params, { addQueryPrefix: true });
    const url = `${this.baseURL}/reports${queryString}`;

    const config =
      params && params.format === "xlsx" ? { responseType: "blob" } : undefined;

    const response = await this.httpClient.request("get", url, config);

    return response;
  }

  async getSupportedHomes(subscriberId) {
    const url = `${this.baseURL}/${subscriberId}/supported_homes`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async bindSupportedHome(subscriberId, params) {
    const url = `${this.baseURL}/${subscriberId}/bind`;
    const response = await this.httpClient.request("post", url, {
      data: params
    });

    return response;
  }

  async getAccountingReports(params) {
    const queryString = qs.stringify(params, { addQueryPrefix: true });
    const url = `${this.baseURL}/reports/accounting${queryString}`;

    const config =
      params && params.format === "xlsx" ? { responseType: "blob" } : undefined;

    const response = await this.httpClient.request("get", url, config);

    return response;
  }
}
